import { NumericReleaseResponseDto } from '@planning/app/api'
import { ReleaseStatus } from '@planning/pages/Releases/models/ReleaseStatus'
import {
  INumericReleaseItem,
  IReleaseItem,
} from '@planning/rt-stores/numericRelease/NumericReleaseItem'
import numericReleaseService from '@planning/services/numericReleaseService'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useReleaseTableColumns } from '../../../tableConfigs/useReleaseTableColumns'
import { ReleaseTable } from '../../molecules/ReleaseTable'
import { ReleaseTableOptions } from '../../molecules/ReleaseTableOptions'

interface Props {
  items: IReleaseItem<NumericReleaseResponseDto>[]
}

export const NumericReleaseTable = observer(({ items }: Props) => {
  const { numericReleaseColumns } = useReleaseTableColumns()

  return (
    <ReleaseTable
      items={items}
      columns={numericReleaseColumns}
      initialFilterStatus={[ReleaseStatus.Open, ReleaseStatus.InProgress]}
      tableName='NumericReleasesTable'
      renderRowActions={({ row }) => {
        const releaseItem = row.original as INumericReleaseItem

        return (
          <ReleaseTableOptions
            id={releaseItem.id}
            canDelete={releaseItem.canDelete}
            onDelete={id => numericReleaseService.delete(id)}
            baseNavigationUrl={PATHS.orders.numericReleases.url}
          />
        )
      }}
    />
  )
})
